import { AdminAuthProvider } from '@/features/admin';
import { AuthProvider } from '@/features/auth';
import { CartProvider } from '@/features/cart';

import { MotionProvider } from './MotionProvider';
import { QueryProvider } from './QueryProvider';
import { ThemeProvider } from './ThemeProvider';

export function AppProviders({ children }) {
  return (
    <ThemeProvider>
      <QueryProvider>
        <AdminAuthProvider>
          <AuthProvider>
            <CartProvider>
              <MotionProvider>{children}</MotionProvider>
            </CartProvider>
          </AuthProvider>
        </AdminAuthProvider>
      </QueryProvider>
    </ThemeProvider>
  );
}
